export default {picturePanel:{titles:['Connection','Authenticity','Experience','Eroticism'],subTitle:'The encounter in parentheses'}};